import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {PreviousDiseasesService} from '../../../core/services/previousDiseases/diseases/previous-diseases.service';

@Component({
  selector: 'previous-diseases-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './previous-diseases-create.component.html',
  styleUrl: './previous-diseases-create.component.scss',
  providers: [HabitsService],
  standalone: true,
})
export class PreviousDiseasesCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private previousDiseasesService: PreviousDiseasesService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.previousDiseasesService.createHabits(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
    })
  }
}
